export default "__VITE_ASSET__BNB8DGI7__"